import React from "react";
import BaseLayout from "@/Layouts/BaseLayout";
import Link from "@/Layouts/Link";
import Picture from "@/Components/Picture";
import "@/Scss/Site/Diamond/index.scss";

const Index = (props) => {
    const {diamonds = []} = props;

    return (
        <BaseLayout {...props}>
            <section className={`section`}>
                <div className={`container`}>
                    <div className={`diamond`}>
                        <div className={`diamond__mainImage`}>
                            <Picture
                                src={`/storage/img/diamond/mainImage.png`}
                                srcMobile={`/storage/img/diamond/mainImageMobile.png`}
                                alt={`mainImage`}
                            />
                        </div>
                        <div className={`diamond__body`}>
                            {diamonds.map((el) => {
                                return (
                                    <Link key={el.id} href={el.link} className={`diamond__item`}>
                                        <Picture src={el.image} srcMobile={el.imageMobile} alt={`Премиум`} />
                                    </Link>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </section>
        </BaseLayout>
    );
}

export default Index;
